import React from "react";
import styled from "styled-components";

export default styled.div`
    flex: 1 1 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
`
